import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './auth/AuthContext'
import ParentPortal from './ParentPortal'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider expectedRole="parent">
        <ParentPortal />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
